import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { retrieveWorksheet, clearWorksheet } from '../features/worksheets/worksheetSlice';
import KeyPointsTable from '../components/KeyPointsTable';
import SentencePagination from '../components/SentencePagination';
import '../styles/WorksheetDetailPage.css';

const WorksheetDetailPage = () => {
  const { id, type } = useParams();
  const dispatch = useDispatch();
  const { worksheet, error } = useSelector((state) => state.worksheet);

  const [currentOverallPage, setCurrentOverallPage] = useState(0);

  useEffect(() => {
    if (id && type) {
      dispatch(retrieveWorksheet({ id, type }));
    }
    return () => {
      dispatch(clearWorksheet());
    };
  }, [id, type, dispatch]);

  if (error) alert('오류가 발생했습니다.');

  const documents = worksheet?.data?.documents || [];
  const paragraphData = documents[0]?.paragraph_data[0] || {};
  const keypoints = paragraphData.keypoints || {};
  const sentenceEngKor = paragraphData.sentence_eng_kor || [];

  const sentencesPerPage = 3;
  const totalSentencePages = Math.ceil(sentenceEngKor.length / sentencesPerPage);
  const paginatedSentences = Array.from({ length: totalSentencePages }, (_, idx) =>
    sentenceEngKor.slice(idx * sentencesPerPage, (idx + 1) * sentencesPerPage)
  );

  const totalPages = 1 + totalSentencePages;

  const progress = (currentOverallPage === 0) ? 50 : 100;

  const handlePrevPage = () => {
    if (currentOverallPage > 0) {
      setCurrentOverallPage((prev) => prev - 1);
    }
  };

  const handleNextPage = () => {
    // 마지막 페이지에서는 다음 이동 불가
    if (currentOverallPage < totalPages - 1) {
      setCurrentOverallPage((prev) => prev + 1);
    }
  };

  const isKeypointsPage = currentOverallPage === 0;
  const sentencePageIndex = currentOverallPage - 1; // 문장 페이지 인덱스

  return (
    <div className="worksheet-detail">
      {/* 진행 바 */}
      <div className="progress-bar">
        <div className="progress" style={{ width: `${progress}%` }} />
        <div className="progress-labels">
          <span className={isKeypointsPage ? 'active' : ''}>핵심 정리</span>
          <span className={!isKeypointsPage ? 'active' : ''}>지문 읽기</span>
        </div>
      </div>

      <div className="worksheet-content">
        {isKeypointsPage && <KeyPointsTable keypoints={keypoints} />}
        {!isKeypointsPage && (
          <SentencePagination
            currentPage={sentencePageIndex}
            sentences={paginatedSentences}
          />
        )}

        <div className="pagination-controls">
          {currentOverallPage > 0 && (
            <div className="arrow left" onClick={handlePrevPage}>
              &lt;
            </div>
          )}

          {currentOverallPage < totalPages - 1 && (
            <div className="arrow right" onClick={handleNextPage}>
              &gt;
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WorksheetDetailPage;